import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";

import Error from "@areas/shared/pages/error/Error";

import Menu from "./Menu";
import Footer from "./Footer";

import { getCurrentModal } from "../modals/functions";

import { layoutActions } from "@store";

export default Layout;

function Layout({ error }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const modal = useSelector((x) => x.layout.modal);

  useEffect(() => {
    dispatch(layoutActions.init());
  }, [dispatch, location]);

  return (
    <div>
      <Animation
        animationIn={animationStyles.swipeTopIn}
        animationOut={animationStyles.swipeTopOut}
      >
        <Menu filter="#9A4610" />
      </Animation>
      {error ? <Error /> : <Outlet />}
      <Animation
        animationIn={animationStyles.swipeTopIn}
        animationOut={animationStyles.swipeTopOut}
      >
        <Footer />
      </Animation>
      {getCurrentModal(modal)}
    </div>
  );
}
